module.exports = __webpack_public_path__ + "img/content-img2_2.cf7140f7.png";